import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';

export const validateSameArray = (arr1: string[], arr2: string[]): boolean => {
  const sorted1 = sortBy(arr1);
  const sorted2 = sortBy(arr2);
  return isEqual(sorted1, sorted2);
};
